<div class="container-fluid">
  <div class="row">
    <div class="col-md-4">
      <div class="card h-auto">
        <div class="card-header bg-light">
          <h4 class="card-title">Upload New Document</h4>
        </div>
        <div class="card-body">
          <form [formGroup]="documentsForm" (ngSubmit)="onSubmit()">
            <div class="row">
              <div class="col-12">
                <input-field [inputFormControl]="getDescription()" label="Description" type="text"
                  placeholder="Enter document description">
              </input-field>
              <div class="custom-file-upload">
                <button type="button" class="btn btn-outline-primary w-100"
                  (click)="fileInput.click()">
                  <i class="fa fa-file me-2"></i>Choose File
                </button>
                <div class="selected-file mt-3">
                  @if (selectedFile) {
                    <div class="selected-file mt-3">
                      <span>Selected: <strong>{{ selectedFile.name }}</strong></span>
                    </div>
                  }
                  @if (!selectedFile) {
                    <div class="selected-file mt-3">
                      <span>No file selected</span>
                    </div>
                  }
                </div>
                <input #fileInput type="file" class="visually-hidden" id="documentFile"
                  (change)="onFileSelected($event)">
              </div>
            </div>
            <div class="col-12 mt-3">
              <button type="submit" class="btn btn-success"
                [disabled]="!documentsForm.valid || !selectedFile">
                <i class="fa fa-save me-2"></i>Save Document
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>

  <div class="col-md-8">
    <div class="card h-100">
      <div class="card-header bg-light">
        <h4 class="card-title">Project Documents</h4>
      </div>
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-striped document-table">
            <thead>
              <tr>
                <th>Description</th>
                <th>File</th>
                <th class="text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              @for (doc of documents; track doc) {
                <tr>
                  <td>{{ doc.description }}</td>
                  <td>
                    <div class="d-flex align-items-center">
                      @if (doc?.attachments) {
                        <span class="me-2">{{
                        doc.attachments[0].fileNameOriginal }}</span>
                      }
                      @if (!doc.attachments[0]?.url) {
                        <span>No file uploaded</span>
                      }
                    </div>
                  </td>
                  <td>
                    <div class="d-flex gap-2">
                      @if (doc.attachments[0]?.url) {
                        <button
                          class="btn btn-outline-secondary btn-sm" (click)="downloadFile(doc)"
                          title="Download file">
                          <i class="fa fa-solid fa-download"></i>
                        </button>
                      }
                      @if (!isEditing || editingDocumentId !== doc.projectDocumentId) {
                        <button class="btn btn-outline-primary btn-sm" (click)="startEditing(doc)"
                          >
                          <i class="fa fa-edit"></i>
                        </button>
                      }
                      @if (!isEditing || editingDocumentId !== doc.projectDocumentId) {
                        <button class="btn btn-danger btn-sm"
                          (click)="openDeleteConfirmation(doc.projectDocumentId)"
                          >
                          <i class="fa fa-trash"></i>
                        </button>
                      }
                    </div>
                  </td>
                </tr>
              }
              @if (documents.length === 0) {
                <tr>
                  <td colspan="3" class="text-center">No documents available</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #editModalContent>
  <div class="modal-header">
    <h5 class="modal-title">Edit Document Description</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="cancelEditing()"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="editForm">
      <input-field [inputFormControl]="getEditFormControl('description')" label="Description"
        type="text" placeholder="Enter document description">
      </input-field>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="cancelEditing()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="saveEdit()"
    [disabled]="!editForm.valid">Save changes</button>
  </div>
</ng-template>
</div>